/**
 * nm-nav-state.js  v2
 * 1. Acordeón: al abrir una categoría cierra las demás
 * 2. Persiste el estado entre páginas (sessionStorage)
 * 3. El resaltado de categoría activa lo maneja server-side (mobile-nav.liquid)
 */
(function () {
  var STORAGE_KEY = 'nm_mobile_nav_open';

  function getOpenKey() {
    try { return sessionStorage.getItem(STORAGE_KEY) || ''; } catch(e) { return ''; }
  }
  function saveOpenKey(key) {
    try { sessionStorage.setItem(STORAGE_KEY, key); } catch(e) {}
  }
  function clearOpenKey() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {}
  }

  // Identificador estable: texto limpio del trigger
  function getKey($el) {
    return $el.clone().children().remove().end().text().trim();
  }

  function closeAll($except) {
    $('.mobile-nav__sublist-trigger.is-active').each(function () {
      var $t = $(this);
      if ($except && $t[0] === $except[0]) return;
      $t.removeClass('is-active').attr('aria-expanded', 'false')
        .next('.mobile-nav__sublist').slideUp(180);
    });
  }

  function init() {
    var $triggers = $('.mobile-nav__sublist-trigger');
    if (!$triggers.length) return;

    // ── 1. Restaurar estado guardado (solo si no hay activo por Liquid) ──
    var savedKey = getOpenKey();
    var hasServerActive = $('.nm-nav__trigger--current').length > 0;

    if (savedKey && !hasServerActive) {
      $triggers.each(function () {
        var $t = $(this);
        if (getKey($t) === savedKey) {
          $t.addClass('is-active').attr('aria-expanded', 'true')
            .next('.mobile-nav__sublist').css('display', 'block');
        }
      });
    }

    // ── 2. Acordeón: interceptar ANTES del handler de theme.js ──
    // Usamos capture-phase con delegación para ir primero
    document.getElementById('MobileNav') && document.getElementById('MobileNav')
      .addEventListener('click', function (e) {
        var trigger = e.target.closest('.mobile-nav__sublist-trigger');
        if (!trigger) return;

        var $trigger = $(trigger);
        var willOpen = !$trigger.hasClass('is-active');

        // Cerrar todos los demás antes de que theme.js abra el actual
        closeAll(willOpen ? $trigger : null);

        // Guardar o limpiar estado
        if (willOpen) {
          saveOpenKey(getKey($trigger));
        } else {
          clearOpenKey();
        }
      }, true); // <-- capture: true → va antes que el listener de theme.js

    // ── 3. Limpiar estado al cerrar el menú overlay completo ──
    $(document).on('click', '#MobileNavTrigger', function () {
      setTimeout(function () {
        var $nav = $('#MobileNav');
        if (!$nav.is(':visible')) clearOpenKey();
      }, 300);
    });
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(init);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      var check = setInterval(function () {
        if (typeof jQuery !== 'undefined') { clearInterval(check); jQuery(document).ready(init); }
      }, 50);
    });
  }
})();
